import { render } from "./EditSession.vue?vue&type=template&id=2a955a8a&scoped=true"
import script from "./EditSession.vue?vue&type=script&lang=js"
export * from "./EditSession.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2a955a8a"

export default script